import React, { ReactNode } from 'react';
import { Grid, GridSize, Box, Typography, useTheme } from '@mui/material';

type WidgetWrapperProps = {
  children: ReactNode;
  size?: 'xlarge' | 'large' | 'medium' | 'small';
  title?: string;
};

const WidgetWrapper: React.FC<WidgetWrapperProps> = ({ children, size = 'medium', title }) => {
  const theme = useTheme();
  const gridSizes: Record<string, { xs: GridSize; md: GridSize; lg: GridSize }> = {
    xlarge: { xs: 12, md: 12, lg: 12 },
    large: { xs: 12, md: 12, lg: 6 },
    medium: { xs: 12, md: 4, lg: 4 },
    small: { xs: 12, md: 3, lg: 2 },
  };

  const selectedSize = gridSizes[size] || gridSizes['medium'];

  return (
    <Grid item
      {...selectedSize}>
      <Box sx={{
        background: theme.palette.common.white,
        borderRadius: '12px',
        border: `1px solid ${theme.palette.custom.gray[300]}`,
        p: 0,
      }}>
        {title && (
          <Box sx={{ p: '24px', pb: '16px', textAlign: 'left' }}>
            <Typography
              variant='textLG'
              sx={{
                fontWeight: 700,
                color: theme.palette.custom.gray[900],
              }}
            >
              {title}
            </Typography>
          </Box>
        )}
        <Box sx={{ px: '24px', pb: '24px', maxHeight: '500px', overflowY: 'auto' }}>
          {children}
        </Box>
      </Box>
    </Grid>
  );
};

export default WidgetWrapper;